var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{'tablet' : _vm.tablet}},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),(_vm.icon)?_c('span',{staticClass:"icon mr-1",class:[ _vm.icon ]}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }